/**
 * The user's "Open project": show that project's workspace whether or not it
 * is already the current one. Switch to it when needed, bring the workspace
 * forward on the desktop, and show it whole (the wall from its top, out of
 * focus; the canvas tidied).
 */
import type { Project } from "@/api/spaces";
import { captureDesktopChatAuthScopeGuard } from "@/desktop/desktop-chat-auth-scope";
import { isTauri } from "@/lib/is-tauri";
import { selectProjectFromUser } from "@/lib/select-project-space";
import { useProjectStore } from "@/stores/project-store";

export async function openProjectWorkspace(project: Project): Promise<void> {
  const isCurrent = captureDesktopChatAuthScopeGuard();
  const { currentProject, projects } = useProjectStore.getState();
  if (currentProject?.id !== project.id)
    selectProjectFromUser(
      projects.find((item) => item.id === project.id) ?? project,
    );
  if (isTauri()) {
    const { openWorkspaceOnActiveDisplay } =
      await import("@/desktop/onboarding/controller-utils");
    await openWorkspaceOnActiveDisplay();
  }
  // Loaded on use, as the other workspace openers do: the view adapters pull
  // in the wall and the canvas.
  const { workspaceViewAdapter } = await import("@/lib/workspace-view-adapter");
  if (isCurrent()) await workspaceViewAdapter().showOverview();
}
